// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1TeamSchema } from './v1/teamSchema';

export const get11AccountIdTeamsSearchPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID for the teams you want to search"),
});

export const get11AccountIdTeamsSearchQueryParamsSchema = z.object({
  q: z.optional(z.coerce.string().describe("Search query")),
  per_page: z.optional(z.number().int().describe("Number of results per page")),
  page: z.optional(z.number().int().describe("Page number")),
}).optional();

export const get11AccountIdTeamsSearchHeaderParamsSchema = z.object({
  Authorization: z.coerce.string(),
});

/**
 * @description Teams found
 */
export const get11AccountIdTeamsSearch200Schema = z.array(z.lazy(() => v1TeamSchema));

export const get11AccountIdTeamsSearchQueryResponseSchema = z.lazy(() => get11AccountIdTeamsSearch200Schema);
